import React from "react";
import PropTypes from "prop-types";
import styles from "./index.module.css";
import CloseButton from "../CloseButton";
import ReactModal from "react-modal";
const Modal = ({ onAfterOpen, onRequestClose, isOpen, children }) => (
  <ReactModal
    className={styles.content}
    closeTimeoutMS={200}
    contentLabel="Modal"
    isOpen={isOpen}
    onAfterOpen={onAfterOpen}
    onRequestClose={onRequestClose}
    overlayClassName={{
      base: styles.overlay,
      afterOpen: styles.overlayAfterOpen,
      beforeClose: styles.overlayBeforeClose
    }}
    parentSelector={() => document.body}
    shouldCloseOnOverlayClick={true}
  >
    <div className={styles.button}>
      <CloseButton inverted onClick={onRequestClose} />
    </div>
    {children}
  </ReactModal>
);

Modal.propTypes = {
  isOpen: PropTypes.bool,
  onAfterOpen: PropTypes.func,
  onRequestClose: PropTypes.func
};

export default Modal;



// WEBPACK FOOTER //
// ./src/components/Modal/index.js